<template>
  <el-dropdown trigger="click" @command="onDownloadClick" :placement="dropdownPosition">
    <span class="dashboard-icon-group">
      <el-tooltip content="다운로드" :placement="toolipePosition">
        <el-button class="btn-download" size="medium" type="content" :disabled="disabled"></el-button>
      </el-tooltip>
    </span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item :command="DashboardConst.DOWNLOAD_TYPE.FILE">백업다운로드</el-dropdown-item>
      <el-dropdown-item :command="DashboardConst.DOWNLOAD_TYPE.IMAGE">이미지다운로드</el-dropdown-item>
    </el-dropdown-menu>
  </el-dropdown>
</template>

<script>
import DashboardAPI from '@/api/dashboard/common';
import DashboardConst from '@/constants/dashboard';

import Base from '@/mixins/dashboard/base';

export default {
  name: 'WDashboardDownloadDropdown',
  mixins: [Base],
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    toolipePosition: {
      type: String,
      default: 'top',
    },
    dropdownPosition: {
      type: String,
      default: 'bottom',
    },
  },
  data() {
    return {
      DashboardConst,
    };
  },
  methods: {
    /**
     * 다운로드 버튼 클릭시 나타나는 dropdown 메뉴의 클릭 이벤트
     * @author JungJioon(ryunnnne)
     * @param  {[type]} command [description]
     * @return {[type]}         [description]
     */
    onDownloadClick(command) {
      if (command === DashboardConst.DOWNLOAD_TYPE.FILE) {
        // 파일 다운로드
        DashboardAPI.downloadDashboard(this.currentDashboardId);
      } else if (command === DashboardConst.DOWNLOAD_TYPE.IMAGE) {
        // 이미지 다운로드
        this.$dashboardEventBus.$emit(DashboardConst.EVENT_BUS.DASHBORD_IMAGE_DOWNLOAD);
      }
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/dashboard/components/DashboardDownloadDropdown.vue